/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.assignments.rpc.OutOfOfficeHoursRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export const BaseChirpErrorDiscriminantKey = '@type';
export type BaseChirpError = ChirpContextError | RoutingExplanationError;

export const ChirpContextErrorTypename =
  'com.hubspot.cv.assignments.core.ChirpContextError';
export const ChirpContextErrorDiscriminant = 'ChirpContextError';
export const ChirpContextErrorDiscriminantKey = '@type';
export type ChirpContextError = {
  errorType: ChirpContextErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.cv.assignments.core.ChirpContextError';
} & { '@type'?: 'ChirpContextError' };

export type ChirpContextErrorType =
  | 'MISSING_PORTAL_ID'
  | 'MISSING_USER_ID'
  | unhandledEnumCase;

export const RoutingExplanationErrorTypename =
  'com.hubspot.cv.assignments.core.routing.explanation.RoutingExplanationError';
export const RoutingExplanationErrorDiscriminant = 'RoutingExplanationError';
export const RoutingExplanationErrorDiscriminantKey = '@type';
export type RoutingExplanationError = {
  errorType: RoutingExplanationErrorType;
  chirpErrorMessage?: string;
  context: Default<Record<string, string>>;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.cv.assignments.core.routing.explanation.RoutingExplanationError';
} & { '@type'?: 'RoutingExplanationError' };

export type RoutingExplanationErrorType =
  | 'NO_AUDIT_EVENTS_FOUND'
  | 'UNABLE_TO_INTERPRET_AUDIT_EVENTS'
  | 'FAILED_AUDIT_INSERT'
  | 'FAILED_RULESET_FETCH'
  | 'FAILED_CHANNEL_FETCH'
  | 'FAILED_BOT_FETCH'
  | unhandledEnumCase;

export type OutOfOfficeStatus = {
  isOutOfOffice: boolean;
  nextOutOfOfficeEventTimestamp?: number;
};

export type FetchOutOfOfficeStatusesRequest = { userIds: Default<number[]> };

export type FetchOutOfOfficeStatusesResponse = {
  statuses: Default<Record<string, OutOfOfficeStatus>>;
};

export type FetchOutOfOfficeStatusesRequestType =
  Requestify<FetchOutOfOfficeStatusesRequest>;
export type FetchOutOfOfficeStatusesResponseType =
  FetchOutOfOfficeStatusesResponse;
export type FetchOutOfOfficeStatusesErrorType = BaseChirpError &
  HubspotMetadata;
export const fetchOutOfOfficeStatusesRpc: ChirpAvroRpcDetails<
  FetchOutOfOfficeStatusesRequestType,
  FetchOutOfOfficeStatusesResponseType,
  FetchOutOfOfficeStatusesErrorType,
  false
> = {
  serviceName: 'com.hubspot.cv.assignments.rpc.OutOfOfficeHoursRpc',
  rpcName: 'fetchOutOfOfficeStatuses',
  auth: 'app',
  fingerprint: 'Qg1J590v3Kg4L-CYf-S5zAAP4KRZT-uF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
